export default __webpack_public_path__ + "web/react/components/oos-send-to-app-modal/images/generic-product-image.7a0675b7f5eb4dc9cf5c91063114c120.png";